import { useEffect } from 'react';

export const useCanonicalUrl = (path) => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = `${window.location.origin}${path}`;
    document.head.appendChild(link);

    return () => link.remove();
  }, [path]);
};
